// Core
import { put, apply } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

// API
import { api } from 'api';

// Actions
import { formCombineActions } from 'redux/form/formActions';
import { uiCombineActions } from 'redux/ui/uiActions';

export function* fetchSuppliersWorker(): SagaIterator {
    try {
        const response = yield apply(api, api.suppliers.fetch, []);
        const data = yield apply(response, response.json, []);

        if (response.status !== 200) {
            throw new Error(data.text);
        }

        yield put(
            formCombineActions.fillSuppliersAction(data.supplier_variants),
        );
    } catch (error: any) {
        yield put(
            uiCombineActions.emitErrorAction(error, 'fetchSuppliers worker'),
        );
    }
}
